import {
  viewPDFColor,
  viewPDFQr,
  pdfReel,
  literformula,
  viewInfoDetails,
  pdfBox,
  regroup,
  reprogram,
  processRemission, 
  updateOrderDetail,
  readyOrderDetail,
  findOrderDetailForWeavingPendingCrudeRolled
} from '../../_services/orderDetail.service';


export const viewPDFColorEvent = async (orderDetail) => {    
  let res = await viewPDFColor(orderDetail);
  return res;
}

export const reprogramEvent = async (orderDetail) => {    
  const body={
    orderDetail
  }
  let res = await reprogram(body);
  return res;
}

export const readyOrderDetailEvent = async (uuid) => {
  if(! uuid) throw new Error('No hay producto especificado');
  let body={
      uuid
  }
  let res = await readyOrderDetail(body);
  if(! res.ok) throw new Error(res.error);
  return res;
}

export const regroupEvent = async (orderDetail,order) => {    
  if(!orderDetail) throw new Error('No hay producto especificado');
  const body={
    order,
    orderDetail
  }
  let res = await regroup(body);
  if(! res.ok) throw new Error(res.error);
  return res;
}



export const viewPDFQrEvent = async (orderDetail,order_uuid) => {    
    const body={order_uuid,
        orderDetail
    }
    let res = await viewPDFQr(body);
    return res;
}

export const pdfReelEvent = async (orderDetail,printBoxBody,infoRol) => {
    if(!orderDetail) throw new Error('No hay producto especificado');
    const body= {
      orderDetail,
      printBoxBody,
      infoRol
    }
    let res = await pdfReel(body);
    //if(! res.ok) throw new Error(res.error);
    return res;
}

export const literformulaEvent = async (literFormula,orderDetail) => {
    if(! orderDetail) throw new Error('No hay producto especificado');
    const body={
        literFormula,
        orderDetail
    }
    let res = await literformula(body);
    //if(! res.ok) throw new Error(res.error);
    return res;
}

export const viewInfoDetailsEvent = async (uuid_details) => {    
  const body={
    uuid_details
  }
    let res = await viewInfoDetails(body);
  return res;
  }

  export const generatePdfBoxEvent = async (body) => {
    if(! body.orderDetail) throw new Error('No hay producto especificado');
    let res = await pdfBox(body);
    //if(! res.ok) throw new Error(res.error);
    return res;
  }

  export const processRemissionEvent = async (selectedRemissions) => {
    const body={
        selectedRemissions
    }
    let res = await processRemission(body);
    if(! res.ok) throw new Error(res.error);
    return res;
}

export const updateOrderDetailEvent = async (dataUpdate,orderDetail) => {    
  if(!orderDetail || !dataUpdate) throw new Error('No hay producto especificado');
  const body={
    orderDetail,
    dataUpdate
  }
  let res = await updateOrderDetail(body);
  if(! res.ok) throw new Error(res.error);
  return res;
}

export const findOrderDetailForWeavingPendingCrudeRolledEvent = async () => {
  let res = await findOrderDetailForWeavingPendingCrudeRolled();
  if(! res.ok) throw new Error(res.error);
  return res;
}